import { useState } from "react";
import { Link } from "react-router-dom";

export default function DeleteAccount() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState(
        `Please delete my Figure It Out account and all associated personal data.

I understand this action is permanent.`
    );

    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState("");

    const CONTACT_URL =
        "https://us-central1-figure-it-out-app.cloudfunctions.net/contact";

    async function handleSubmit(e) {
        e.preventDefault();

        setSending(true);
        setStatus("");

        try {

            const response = await fetch(CONTACT_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name,
                    email,
                    message,
                    type: "account-deletion"
                })
            });

            if (!response.ok) {
                throw new Error();
            }

            setStatus(
                "Your account deletion request has been received. We will process your request as soon as possible."
            );

            setName("");
            setEmail("");
            setMessage(
                `Please delete my Figure It Out account and all associated personal data.

I understand this action is permanent.`
            );

        } catch {

            setStatus(
                "Sorry, something went wrong. Please try again."
            );

        }

        setSending(false);
    }

    return (
        <div style={{ padding: "2rem" }}>
           <Link to="/" className="safe-top-link">
    ← Home
</Link>

            <h1>Delete Account</h1>

            <p>
                You may request deletion of your Figure It Out account and
                associated personal data at any time.
            </p>

            <p>
                When your request has been verified, we will permanently delete:
            </p>

            <ul>
                <li>Your Figure It Out account</li>
                <li>Your learning progress</li>
                <li>Your journal entries</li>
                <li>Other personal information associated with your account</li>
            </ul>

            <p>
                This process cannot be undone.
            </p>

            <form onSubmit={handleSubmit}>

                <div>
                    <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Name"
                        required
                    />
                </div>

                <br />

                <div>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email address used for your account"
                        required
                    />
                </div>

                <br />

                <div>
                    <textarea
                        rows="6"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    />
                </div>

                <br />

                <button
                    type="submit"
                    disabled={sending}
                >
                    {sending
                        ? "Sending..."
                        : "Request Account Deletion"}
                </button>

            </form>

            {status && <p>{status}</p>}
        </div>
    );
}